import {Button, Image, List, Modal, ModalProps} from "antd";
import {useLazyGetAssetsListQuery} from "../../../../../../store/services/api/asset-api";
import React, {useEffect, useState} from "react";
import {fallbackImage} from "../../../../../../constants/FallbackImage";

type SelectAssetModalProps = Omit<ModalProps, 'children' | 'title' | 'loading' | 'onOk'> & {
  query: Record<string, any>;
  onAssetSelected?: (assetId: string) => void;
  onOk?: (assetId: string) => void;
}

export default function SelectAssetModal(props: SelectAssetModalProps) {
  const [getAssetsList, {isFetching: assetsLoading}] = useLazyGetAssetsListQuery();
  const [selectedAssetId, setSelectedAssetId] = useState<string | undefined>(undefined);
  const [assets, setAssets] = useState<any[]>([]);
  const [pageNumber, setPageNumber] = useState<number>(0);
  const [hasMore, setHasMore] = useState<boolean>(false);

  useEffect(() => {
    if (!props.open || !props.query) {
      setAssets([]);
      setPageNumber(0);
      setHasMore(false);
      setSelectedAssetId(undefined);
      return;
    }

    getAssetsList({
      ...props.query,
      pageNumber: pageNumber + 1
    }).unwrap()
      .then(res => {
        setAssets(curr => [...curr, ...res.list]);
        setHasMore(res.pagination.hasNext);
      });
  }, [props.open, props.query, pageNumber]);

  const onLoadMore = () => {
    setPageNumber(curr => curr + 1);
  }

  return (
    <Modal
      title='Select Asset'
      {...props}
      onOk={() => props.onOk?.(selectedAssetId)}
      okButtonProps={{
        disabled: !selectedAssetId
      }}
    >
      <List
        itemLayout="vertical"
        dataSource={assets}
        size='small'
        loadMore={<Button block onClick={onLoadMore} loading={assetsLoading} disabled={!hasMore}>Load More</Button>}
        loading={assetsLoading}
        style={{overflow: 'scroll', maxHeight: '50vh'}}
        renderItem={(item,) => {
          const getDescription = () => {
            let description = `${item.buildingName} - ${item.floorName} - ${item.locationName}`;
            description += `\n\n ${item.assetTypeName} - ${item.subAssetTypeName}`;
            return description;
          }

          return (
            <List.Item
              style={{
                backgroundColor: item.id === selectedAssetId ? '#e6f7ff' : undefined,
                cursor: 'pointer',
                paddingInline: 12
              }}
              onClick={() => {
                setSelectedAssetId(item.id);
                props.onAssetSelected?.(item.id);
              }}
            >
              <List.Item.Meta
                avatar={(
                  <Image
                    preview={!!item.imageUri}
                    src={item.imageUri}
                    height={42}
                    width={42}
                    style={{borderRadius: 4, borderWidth: 0}}
                    fallback={fallbackImage}
                  />
                )}
                title={item.code}
                description={getDescription()}
              />
            </List.Item>
          )
        }}
      />
    </Modal>
  )
}
